import { defineMessages } from 'react-intl';

const scope = 'app.legacy.main.components.common.headers';


export default defineMessages({
    dashboardLink: {
        id: `${scope}.dashboardLink`,
        description: 'Link to the dashboard page',
        defaultMessage: 'Dashboard',
    },
    dashboardV2Link: {
        id: `${scope}.dashboardV2Link`,
        description: 'Link to the dashboard V2 page',
        defaultMessage: 'Dashboard Beta',
    },
    overviewLink: {
        id: `${scope}.overviewLink`,
        description: 'Main nav heading for the overview pages',
        defaultMessage: 'Overview',
    },
    yearOverviewLink: {
        id: `${scope}.yearOverviewLink`,
        description: 'Link to the year overview page',
        defaultMessage: 'Yearly',
    },
    monthOverviewLink: {
        id: `${scope}.monthOverviewLink`,
        description: 'Link to the month overview page',
        defaultMessage: 'Monthly',
    },
    dayOverviewLink: {
        id: `${scope}.dayOverviewLink`,
        description: 'Link to the day overview page',
        defaultMessage: 'Daily',
    },
    revflowLink: {
        id: `${scope}.revflowLink`,
        description: 'Link to the revflow page',
        defaultMessage: 'Revflow',
    },
    rateCalendarLink: {
        id: `${scope}.rateCalendarLink`,
        description: 'Link to the rate calendar page',
        defaultMessage: 'Rate Calendar',
    },
    recommendationsLink: {
        id: `${scope}.recommendationsLink`,
        description: 'Link to the recommendations page',
        defaultMessage: 'Recommendations',
    },
    cardinalRateCalendarLink: {
        id: `${scope}.cardinalRateCalendarLink`,
        description: 'Link to the rate calendar',
        defaultMessage: 'Rate Calendar',
    },
    cancellationReportLink: {
        id: `${scope}.cancellationReportLink`,
        description: 'Link to the cancellation report',
        defaultMessage: 'Cancellation Report',
    },
    reservationReportLink: {
        id: `${scope}.reservationReportLink`,
        description: 'Link to the reservation report',
        defaultMessage: 'Reservation Report',
    },
    comparisonReportLink: {
        id: `${scope}.comparisonReportLink`,
        description: 'Link to comparison report',
        defaultMessage: 'Comparison Report',
    },
    segmentationReportLink: {
        id: `${scope}.segmentationReportLink`,
        description: 'Link to segmentation report',
        defaultMessage: 'Segmentation Report',
    },
    fiscalBreakdownReportLink: {
        id: `${scope}.fiscalBreakdownReportLink`,
        description: 'Link to fiscal breakdown report',
        defaultMessage: 'Fiscal Breakdown',
    },
    pickupReportLink: {
        id: `${scope}.pickupReport`,
        description: 'Link to the pickup report',
        defaultMessage: 'Pickup Report',
    },
    pickupReportV2Link: {
        id: `${scope}.pickupReportV2Link`,
        description: 'Link to the pickup report version two',
        defaultMessage: 'Pickup Report',
    },
    pickupReportV3Link: {
        id: `${scope}.pickupReportV3Link`,
        description: 'Link to the pickup report version three',
        defaultMessage: 'Pickup Report V3',
    },
    commissionReportLink: {
        id: `${scope}.commissionReportLink`,
        description: 'Link to the commission report',
        defaultMessage: 'Commission Report',
    },
    sellingRateReportLink: {
        id: `${scope}.sellingRateReportLink`,
        description: 'Link to the selling rate report',
        defaultMessage: 'Selling Rate Report',
    },
    groupPickupReportLink: {
        id: `${scope}.groupPickupReportLink`,
        description: 'Link to the group pickup report',
        defaultMessage: 'Group Reporting',
    },
    customisedReportLink: {
        id: `${scope}.customisedReportLink`,
        description: 'Link to the custpmised report',
        defaultMessage: 'Customised Report',
    },
    statisticsLink: {
        id: `${scope}.statisticsLink`,
        description: 'Link to the stats dashboard',
        defaultMessage: 'Statistics',
    },
    recommendationReportLink: {
        id: `${scope}.recommendationReportLink`,
        description: 'Link to the recommendations report',
        defaultMessage: 'Recommendations',
    },
    otaParityLink: {
        id: `${scope}.otaParityLink`,
        description: 'Link to the OTA Parity report',
        defaultMessage: 'OTA Parity',
    },
    costCalculatorLink: {
        id: `${scope}.costCalculatorLink`,
        description: 'Link to the cost calculator',
        defaultMessage: 'Cost Calculator',
    },
    profitPredictorLink: {
        id: `${scope}.profitPredictorLink`,
        description: 'Link to the profit predictor',
        defaultMessage: 'Profit Predictor',
    },
    groupDispLink: {
        id: `${scope}.groupDispLink`,
        description: 'Link to group displacement calculator',
        defaultMessage: 'Group Displacement',
    },
    rateChangeImpactLink: {
        id: `${scope}.rateChangeImpactLink`,
        description: 'Link to rate change impact calculator',
        defaultMessage: 'Rate Change Impact',
    },
    adminLink: {
        id: `${scope}.adminLink`,
        description: 'Link to admin page',
        defaultMessage: 'Admin',
    },
    settingsLink: {
        id: `${scope}.settingsLink`,
        description: 'Link to settings page',
        defaultMessage: 'Settings',
    },
    logoutLink: {
        id: `${scope}.logoutLink`,
        description: 'Logout',
        defaultMessage: 'Logout',
    },
    financeHubLink: {
        id: `${scope}.financeHubLink`,
        description: 'Link to finance hub page',
        defaultMessage: 'Finance Hub',
    },
    financeHubBusinessChangeLink: {
        id: `${scope}.financeHubBusinessChangeLink`,
        description: 'Link to finance hub business change page',
        defaultMessage: 'Business Change',
    },
    financeHubSummaryLink: {
        id: `${scope}.financeHubSummaryLink`,
        description: 'Link to finance hub summary page',
        defaultMessage: 'Monthly Summary',
    },
    financeHubMonthlyTotalsLink: {
        id: `${scope}.financeHubMonthlyTotalsLink`,
        description: 'Link to finance hub monthly totals page',
        defaultMessage: 'High-level Pick-up',
    },
    financeHubSegmentationLink: {
        id: `${scope}.financeHubSegmentationLink`,
        description: 'Link to finance hub segmentation page',
        defaultMessage: 'Segmentation',
    },
    financeHubSegmentationV2Link: {
        id: `${scope}.financeHubSegmentationV2Link`,
        description: 'Link to finance hub segmentation V2 page',
        defaultMessage: 'Segmentation V2',
    },
    budgetCalculatorLink: {
        id: `${scope}.budgetCalculatorLink`,
        description: 'Link to budget calculator page',
        defaultMessage: 'Budget Calculator',
    },
    settingsMainLink: {
        id: `${scope}.settingsMainLink`,
        description: 'Settings Menu',
        defaultMessage: 'Settings',
    },
    settingsCalendarLink: {
        id: `${scope}.settingsCalendarLink`,
        description: 'Link to settings calendar',
        defaultMessage: 'Calendar',
    },
    settingsBulkUpdateLink: {
        id: `${scope}.settingsBulkUpdateLink`,
        description: 'Link to settings bulk update page',
        defaultMessage: 'Bulk Update',
    },
    settingsSellingRateMassUpdateLink: {
        id: `${scope}.settingsSellingRateMassUpdateLink`,
        description: 'Link to settings selling rate mass update page',
        defaultMessage: 'Selling Rate Update',
    },
    settingsSegmentBucketsLink: {
        id: `${scope}.settingsSegmentBucketsLink`,
        description: 'Link to segment buckets management page',
        defaultMessage: 'Segment Buckets',
    },
    settingsOtaCompsetsLink: {
        id: `${scope}.settingsOtaCompsetsLink`,
        description: 'Link to OTA compsets management page',
        defaultMessage: 'OTA Competitor Sets',
    },
    settingsScheduledReportsLink: {
        id: `${scope}.settingsScheduledReportsLink`,
        description: 'Link to scheduled reports management page',
        defaultMessage: 'Scheduled Reports',
    },
    settingsRoomsLink: {
        id: `${scope}.settingsRoomsLink`,
        description: 'Link to rooms management page',
        defaultMessage: 'Rooms',
    },
    settingsPropertiesLink: {
        id: `${scope}.settingsPropertiesLink`,
        description: 'Link to properties management page',
        defaultMessage: 'Properties',
    },
    settingsEventsLink: {
        id: `${scope}.settingsEventsLink`,
        description: 'Link to events management page',
        defaultMessage: 'Events',
    },
    adminPropertiesLink: {
        id: `${scope}.adminPropertiesLink`,
        defaultMessage: 'Properties',
    },
    adminUsersLink: {
        id: `${scope}.adminUsersLink`,
        defaultMessage: 'Users',
    },
    adminBudgetLink: {
        id: `${scope}.adminBudgetLink`,
        defaultMessage: 'Budget',
    },
    adminSchedulerLink: {
        id: `${scope}.adminSchedulerLink`,
        defaultMessage: 'Scheduler',
    },
    adminCreationLink: {
        id: `${scope}.adminCreationLink`,
        defaultMessage: 'Property creation',
    },
    adminAccountManagementLink: {
        id: `${scope}.adminAccountManagementLink`,
        defaultMessage: 'Account Management',
    },
    adminNotificationsLink: {
        id: `${scope}.adminNotificationsLink`,
        defaultMessage: 'Send Notification',
    },
    hurdleRackAdvisorLink: {
        id: `${scope}.hurdleRackAdvisorLink`,
        defaultMessage: 'Hurdle/Rack Advisor',
    },
    rateCodeManagementLink: {
        id: `${scope}.rateCodeManagementLink`,
        defaultMessage: 'Rate Codes',
    },
    componentRoomsManagementLink: {
        id: `${scope}.componentRoomsManagementLink`,
        defaultMessage: 'Component Rooms',
    },
    alertModalCloseButtonText: {
        id: `${scope}.alert.button.close`,
        defaultMessage: 'I acknowledge',
    },
    alertModalViewButtonText: {
        id: `${scope}.alert.button.view`,
        defaultMessage: 'View',
    },
    budgetCreatorLink: {
        id: `${scope}.budgetCreatorLink`,
        description: 'Link to budget builder page',
        defaultMessage: 'Budget Builder',
    },
});